import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/api/queryKeys";
import { toast } from "@/lib/toast";
import { toastError } from "@/lib/userMessages";
import { testByokKey } from "../api";
import type { ByokKey } from "../types";

export function useTestByokKey() {
  const qc = useQueryClient();
  return useMutation<ByokKey, unknown, string>({
    mutationFn: testByokKey,
    onSuccess: (data) => {
      if (data.status === "valid") toast.success("Chave válida");
      else toast.error("Chave inválida ou sem permissão. Verifique a chave e tente novamente.");
      qc.invalidateQueries({ queryKey: queryKeys.byok.all });
    },
    onError: (err) => toastError(err, "Não foi possível testar a chave. Tente novamente."),
  });
}
